@if (withShell) {
<astral-field-shell [control]="control" [forId]="resolvedInputId" [helpText]="helpText">
  <ng-container [ngTemplateOutlet]="textareaTemplate"></ng-container>
</astral-field-shell>
} @else {
  <ng-container [ngTemplateOutlet]="textareaTemplate"></ng-container>
}

<ng-template #textareaTemplate>
  <div
    class="astral-textarea"
    [class.astral-textarea--readonly]="control?.isReadonly"
    [class.astral-textarea--disabled]="control?.disabled"
    [class.astral-textarea--focused]="isFocused"
  >
    <div class="astral-textarea__control-shell" [class.astral-textarea__control-shell--readonly]="control?.isReadonly">
      @if (control?.isReadonly) {
        <span class="astral-textarea__readonly-icon" aria-hidden="true">
          <i [class]="readonlyIconClass"></i>
        </span>
      }

      <textarea
        #textarea
        astralFieldAccessibility
        [astralFieldControl]="accessibilityControl ?? control"
        [astralFieldHelpText]="helpText"
        [astralFieldInputId]="resolvedInputId"
        class="astral-textarea__control"
        [formControl]="control"
        [attr.id]="resolvedInputId"
        [attr.name]="resolvedInputName"
        [attr.rows]="rows"
        [attr.maxlength]="maxLength ?? null"
        [attr.aria-describedby]="displaysCharacterCount ? characterCountId : null"
        [attr.placeholder]="resolvedPlaceholderText ? (resolvedPlaceholderText | translate) : null"
        [readonly]="control?.isReadonly ? true : null"
        [required]="control?.required ? true : null"
        (blur)="handleBlur()"
        (focus)="handleFocus()"
        (keydown)="onKeyDown($event)"
        (input)="onInput($event)"
      ></textarea>
    </div>
    @if (displaysCharacterCount) {
      <span
        class="astral-textarea__character-count"
        [attr.id]="characterCountId"
        [attr.aria-label]="'COMMON.CHARACTER_COUNT' | translate: { current: currentLength, maximum: maxLength }"
        aria-live="polite"
      >{{ currentLength }} / {{ maxLength }}</span>
    }
  </div>
</ng-template>
